module.exports = __webpack_public_path__ + "static/laptop-cpr-ee8f6462dd4f7b47ac61e7ea3e1d50ee.png";